
import { useState, useEffect, useRef } from "react"
import { Outlet } from "react-router-dom"
import { Sidebar } from "@/components/layout/sidebar"
import { Header } from "@/components/layout/header"

export function MainLayout() {
  const resizeTimeoutRef = useRef<NodeJS.Timeout | undefined>(undefined)

  // Detect mobile and set sidebar collapsed by default on mobile (StrictMode safe)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < 1024 // lg breakpoint
    }
    return true // Default to collapsed for SSR
  })

  // Handle window resize to auto-collapse on mobile and auto-expand on desktop (StrictMode safe)
  useEffect(() => {
    const handleResize = () => {
      // Debounce resize events to prevent rapid state changes
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current)
      }

      resizeTimeoutRef.current = setTimeout(() => {
        if (typeof window !== 'undefined') {
          const isMobile = window.innerWidth < 1024
          // Colapsar en móvil, expandir en desktop
          setSidebarCollapsed(isMobile)
        }
      }, 100)
    }

    // Set initial state
    if (typeof window !== 'undefined') {
      setSidebarCollapsed(window.innerWidth < 1024)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current)
      }
    }
  }, [])

  return (
    <div className="flex min-h-dvh bg-background">
      <Sidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
      />

      <div className="flex-1 flex flex-col">
        <Header
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        />

        <main>
          <Outlet />
        </main>
      </div>
    </div>
  )
} 